import React from 'react';

interface NoDataOverdueIconProps {
  className?: string;
  size?: number;
}

const NoDataOverdueIcon: React.FC<NoDataOverdueIconProps> = ({ 
  className = "w-24 h-24 text-gray-300", 
  size = 24 
}) => {
  return (
    <div className={className}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-full h-full"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12,6 12,12 16,14" />
        <path d="M9 9h6" />
        <path d="M9 15h6" />
      </svg>
    </div>
  );
};

export default NoDataOverdueIcon;
